import { IRole } from './../models/IRole';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { IUser } from 'app/models/IUser';
import { IOrg } from 'app/models/IOrg';


@Injectable()
export class UserService {
  public user: Subject<IUser> = new Subject<IUser>();
  //private state$ = new BehaviorSubject<any>('initialState');
  public users: IUser[];

  constructor(private baseService: BaseService) { }

  changeUser(user: IUser) {
    this.user.next(user);

  }
  getUser(): Observable<IUser> {
    return this.user;
  }

  getUsers() {
    return this.baseService.sendHttpGet('/admin/getusers');  
  }

  getUsersbyOrgbyRole(org: IOrg, role: IRole) {
    return this.baseService.sendHttpGet('/admin/getusers', [org, role]);  
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/user.service.ts